import { useMemo } from "react";

import { Checkbox, FormControl, FormControlLabel, FormHelperText } from "@mui/material";

import { AccountManagersHooks } from "../../../../Context/customer/AccountManagers";
import { useUserContext } from "../../../../Context/UserContext";
import { DATA_CY_GENERAL_SETTINGS_SELECTORS } from "../helpers";
import { SettingsAdminItemWrapper } from "../SettingsAdminItemWrapper";
import { type SettingsValuesType } from "../types";

export function SkipRemedyBreach({
  value,
  onChange,
  errMsg,
}: {
  value: SettingsValuesType["skipRemedyBreach"];
  onChange: (newVal: SettingsValuesType["skipRemedyBreach"]) => void;
  errMsg: string | undefined;
}) {
  const [allAccountManagers] = AccountManagersHooks.useAllAccountManagers();
  const { userModel } = useUserContext();

  const isAccountManager = useMemo<boolean>(
    () =>
      !!allAccountManagers?.length &&
      !!allAccountManagers.find((am) => am.id === userModel?.id && am.role === "account_manager"),
    [allAccountManagers, userModel?.id]
  );

  return (
    <SettingsAdminItemWrapper disabledForTrial={true}>
      {(isDisabled) => (
        <FormControl disabled={!isAccountManager && isDisabled}>
          <FormControlLabel
            sx={{ ml: -1 }}
            control={
              <Checkbox
                sx={{ padding: 0.75 }}
                name="skipRemedyBreach"
                checked={value}
                data-cy={DATA_CY_GENERAL_SETTINGS_SELECTORS.SKIP_REMEDY_BREACH}
                onChange={(e) => {
                  onChange(e.target.checked);
                }}
                size="small"
              />
            }
            label="Skip notice to remedy breaches of contract and overdue payment alerts"
          />
          {!!errMsg && <FormHelperText sx={{ display: "flex", color: "error.main" }}>{errMsg}</FormHelperText>}
        </FormControl>
      )}
    </SettingsAdminItemWrapper>
  );
}
